(() => {
  function configurations(form) {
    const selector = form?.querySelector('[data-aura-configuration]');
    if (!selector) return null;
    const labels = [...selector.querySelectorAll('label')];
    if (labels.length !== 2) return null;
    const byName = name => labels.find(label => label.textContent.trim().toLowerCase() === name)?.control;
    const bed = byName('1 bed'), pieces = byName('2 pieces');
    return bed && pieces ? { selector, bed, pieces } : null;
  }
  // Update both options before the native variant picker reads the change event.
  document.addEventListener('change', event => {
    const input = event.target;
    if (!input.matches('.ae-bedding-sizes input[type="radio"]')) return;
    const pair = configurations(input.closest('.ae-bedding-form'));
    if (!pair) return;
    const target = input.closest('.ae-size-card--pieces') ? pair.pieces : pair.bed;
    target.checked = true;
  }, true);
  function scan() {
    document.querySelectorAll('.ae-bedding-form').forEach(form => {
      const pair = configurations(form);
      if (pair) pair.selector.classList.add('ae-configuration-auto');
    });
  }
  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
